/* eslint-disable no-console */
import { select } from 'redux-saga/effects';
import { setNotification } from 'utils';
import { getAddressesApi, getContactsApi, getCustomersApi } from '../api/customerApi';
import { getUsersApi } from '../api/userApi';
import { getConfigurationsApi } from '../api/configurationApi';
import { getProductGroupsApi } from '../api/productGroupApi';
import { getPaymentTypesApi, getOrderApi } from '../api/orderApi';
import { getShippingTypesApi } from '../api/shippingTypeApi';
import { getMachinesApi } from '../api/machineApi';
import { getTemplateApi } from '../api/templateApi';

const getLayout = state => state.layout;

export function* getConfigurationsMacro(ids) {
    try {
        const params = {
            filter: JSON.stringify({
                _id: ids,
                all: true,
            }),
            limit: ids.length,
        };

        const result = yield getConfigurationsApi(params);
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export function* getProductGroupsMacro(ids) {
    try {
        const result = yield getProductGroupsApi({
            filter: JSON.stringify({ _id: ids }),
            limit: ids.length,
        });

        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export function* getUsersMacro(ids) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield getUsersApi({
            filter: JSON.stringify({
                _id: ids,
            }),
            limit: ids.length,
        });

        if (result.status === 401) {
            setNotification('error', locale, 'global.error', 'order.notification.accessUserError');
        }

        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export function* getAddressesMacro(ids) {
    try {
        const result = yield getAddressesApi({
            filter: JSON.stringify({ _id: ids }),
            type: 'SHIPPING',
            limit: ids.length,
        });

        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export function* getShippingTypeMacro(ids) {
    try {
        const params = {
            filter: JSON.stringify({
                _id: ids,
            }),
            limit: ids.length,
        };

        const result = yield getShippingTypesApi(params);
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export function* getMachinesMacro(ids) {
    try {
        const params = {
            filter: JSON.stringify({ _id: ids }),
            limit: ids.length,
        };

        const result = yield getMachinesApi(params);
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export function* getPaymentTypesMacro(ids) {
    try {
        const params = {
            filter: JSON.stringify({ _id: ids }),
            limit: ids.length,
        };

        const result = yield getPaymentTypesApi(params);
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export function* getCustomersMacro(ids) {
    try {
        const params = {
            filter: JSON.stringify({ _id: ids }),
            joins: JSON.stringify(['main_contact']),
            limit: ids.length,
        };

        const result = yield getCustomersApi(params);
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export function* getContactsMacro(ids) {
    try {
        const params = {
            filter: JSON.stringify({ _id: ids }),
            limit: ids.length,

        };

        const result = yield getContactsApi(params);
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export function* getOrderMacro(ids) {
    try {
        const params = {
            filter: JSON.stringify({ _id: ids }),
            offset: 0,
            limit: 999,
        };

        const result = yield getOrderApi(params);
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export function* getTemplatesByPackagesApi(ids) {
    try {
        const params = {
            filter: JSON.stringify({ packages_id: ids }),
            limit: ids.length,
        };

        const result = yield getTemplateApi(params);
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
}
